import React, { memo } from 'react';
import { useRouter } from 'next/router';
import { Footer } from '@havenengineering/module-shared-haven-ui-layout/dist/components/Footer';
import { useUnleash } from '../../../../providers/unleashProvider';
import { analytics } from '../../../../helpers/gtm/analytics';
import styles from './default-footer.module.scss';

const MainFooter = () => {
  const { query } = useRouter();
  const { isUnleashVariantActiveCsr } = useUnleash();
  const hideFooterEnabled = isUnleashVariantActiveCsr('search-0417-hide-static-footer', '1', query);

  if (hideFooterEnabled) {
    return null;
  }

  return (
    <>
      <Footer showNavigation={false} analytics={analytics} />
      <div className={styles.footerSpacer} />
    </>
  );
};

export const DefaultFooter = memo(MainFooter);
